// @flow

/**
 * Module dependencies.
 */

import { asset } from 'core/utils';
import { compose, defaultProps } from 'recompose';
import { position } from 'polished';
import { setStylesProp } from 'client/styles';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  extension: string,
  filename: string,
  type: string
};

/**
 * `Image` component.
 */

const Image = styled.picture`
  ${position('absolute', '0', '0', '0', '0')};

  background-image: url(${({ defaultImage }) => defaultImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${({ backgroundSize }) => backgroundSize};

  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
   only screen and (min--moz-device-pixel-ratio: 1.3),
   only screen and (-o-min-device-pixel-ratio: 1.3/1),
   only screen and (min-resolution: 144dpi),
   only screen and (min-resolution: 1.5dppx): {
    background-image: url(${({ retinaImage }) => retinaImage});
  }

  ${setStylesProp};
`;

/**
 * `BackgroundImage` component.
 */

function BackgroundImage(props: Props): React$Element<*> {
  const { extension, filename, type, ...rest } = props;

  return (
    <Image
      {...rest}
      backgroundSize={type}
      defaultImage={asset(require(`client/assets/images/${filename}.${extension}`))}
      retinaImage={asset(require(`client/assets/images/${filename}@2x.${extension}`))}
    />
  );
}

/**
 * Export `BackgroundImage`.
 */

export default compose(
  defaultProps({
    extension: 'jpg',
    type: 'cover'
  })
)(BackgroundImage);



// WEBPACK FOOTER //
// ../src/client/components/core/images/background-image.js